import React, { Component } from 'react';
import PropTypes from 'prop-types'
import Drawer from '../../../Common/Drawer/Drawer';
import Toggle from '../../../Common/Toggle/Toggle';

export default class ColumnFiltersDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            columns: []
        }
    }

    componentDidMount() {
        // Caching values locally so changes do not take effect until save
        this.setState({ columns: this.props.columns });
    }

    onSave = async () => {
        this.props.onComplete(this.state.columns);
    }

    onToggleChange = (name, value) => {
        const newColumns = this.state.columns.slice();
        const column = this.state.columns.find(x => x.field === name);
        column.isEnabled = value;
        this.setState({ values : newColumns});
    }

    render() {
        return (
            <Drawer isOpen={true} isWide={false} title='Columns'
                onSaveClick={this.onSave}
                saveText='Save'
                onCancelClick={this.props.onCancel}>
                {
                    this.state.columns.map(column => 
                        <div key={column.field}>
                            <Toggle name={column.field} text={column.header} checked={column.isEnabled} onChange={this.onToggleChange} />
                        </div>
                    )
                }
            </Drawer>
        )
    }
}

ColumnFiltersDrawer.propTypes = {
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    columns: PropTypes.array.isRequired
};
